import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { loadUtmify } from "./utils/utmify";
loadUtmify();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-345" data-mp="218wf930448bi" />);
}